import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuctionHaltButtonProps } from './interface'

export const AuctionHaltButton = ({ record }: AuctionHaltButtonProps) => {
  const { setCurrentAuction, toggleHaltFormVisible } = useAuctionListStore(
    state => pick(state, ['setCurrentAuction', 'toggleHaltFormVisible'])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleHaltFormVisible(true)
  }

  return record.status === AuctionOperationPageStatus.ENTRUST_HALT ? (
    <Button type='link' onClick={handleClick}>
      终止交易
    </Button>
  ) : null
}
